<ng-container *ngIf="isLoggedIn$ | async">
  <div class="modal-header cx-dialog-header">
    <h3 class="modal-title">
      {{ 'closeAccount.confirmAccountClosure' | cxTranslate }}
    </h3>
    <button
      type="button"
      class="close"
      [attr.aria-label]="'common.close' | cxTranslate"
      (click)="dismissModal()"
    >
      <span aria-hidden="true">
        <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
      </span>
    </button>
  </div>

  <div *ngIf="isLoading$ | async; else loaded">
    <div class="cx-spinner">
      <cx-spinner> </cx-spinner>
    </div>
  </div>

  <ng-template #loaded>
    <div class="modal-body">
      <div class="cx-row">
        <p class="cx-confirmation">
          {{ 'closeAccount.confirmAccountClosureMessage' | cxTranslate }}
        </p>
      </div>
      <div class="cx-row">
        <div class="cx-btn-group">
          <button class="btn btn-primary" (click)="closeAccount()">
            {{ 'closeAccount.closeMyAccount' | cxTranslate }}
          </button>
          <button (click)="dismissModal()" class="btn btn-block btn-secondary">
            {{ 'common.cancel' | cxTranslate }}
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</ng-container>
